import React from 'react'
import { DictionaryValue, SocialButton } from '../../components'
import { Auth } from 'aws-amplify'
import './FederatedLogin.scss'

class FederatedLogin extends React.Component {
  handleSocialClick(provider: string) {
    return async () => {
      try {
        // Store the provider so we know which one to use on the retry
        localStorage.setItem('federated_provider', provider)
        await Auth.federatedSignIn({
          customProvider: provider,
        })
      } catch (error) {
        // This will likely only catch configuration errors, not the redirect error.
        console.error('Error initiating federated sign-in:', error)
        localStorage.removeItem('federated_provider')
      }
    }
  }

  render() {
    return (
      <div className='federated-login '>
        <SocialButton
          brand='Facebook'
          onClick={this.handleSocialClick('Facebook')}
        >
          <DictionaryValue token='login.social.facebook' />
        </SocialButton>
        <SocialButton
          brand='Google'
          onClick={this.handleSocialClick('Google')}
        >
          <DictionaryValue token='login.social.google' />
        </SocialButton>
        <div className='federated-login__or'>
          <DictionaryValue token='login.social.or' />
        </div>
      </div>
    )
  }
}

export { FederatedLogin }
